import React from 'react'
import { Field } from 'redux-form'
import YourStoreFieldComponent from './YourStoreFieldComponent'
import model from '../../QuickAppointmentPage/viewModel'

const BOTYourStore = ({
  ...props
}) =>
  <Field
    { ...props }
    { ...model.storeSelector }
    component={ YourStoreFieldComponent } />

export default BOTYourStore
